import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { translate, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import {
    Rate, Row, Col, Icon, Collapse
} from 'antd';

import cn from '../../../utils/cn';
import Button from '../../../components/button';
import '../style.less';
import * as constants from '../../../constants';
import { selectors, actions } from '../../../models';
import { Title } from '../../../components';

const { Panel } = Collapse;
const {
    getCurrentPesticide
} = selectors;

const mstp = (state) => ({
    pesticide: getCurrentPesticide(state)
});

@withRouter
@connect(mstp, {})
@withTranslation('pesticide modal')
@cn('pesticide-detail')
export default class PesticidePrice extends Component {
    goBack = () => {
        const { history } = this.props;
        history.push('/pesticides');
    };

    render() {
        const { cn } = this;
        const {
            t, pesticide,
            onTabChange
        } = this.props;
        if (!pesticide) return <div />;
        return (

            <div className={cn()}>
                <div className={cn('content')}>
                    <span className={cn('back')} onClick={this.goBack}>
                        {t('back')}
                    </span>
                    <div className={cn('title')}>
                        {pesticide.title}
                    </div>
                    { /* <div className={cn('rate')}>
                        <Rate disabled allowHalf defaultValue={2.5} />
                        <div className={cn('rate', 'value')}>2.5</div>
                    </div> */ }
                    <Row gutter={20} style={{ marginTop: '45px' }}>
                        <Col span={6}>
                            {t('registrant')}
                        </Col>
                        <Col span={6}>
                            {pesticide.registrant}
                        </Col>
                    </Row>
                    <Row gutter={20} style={{ marginTop: '20px' }}>
                        <Col span={6}>
                            {t('price')}
                        </Col>
                        <Col span={6}>
                            {pesticide.averagePrice}
                        </Col>
                    </Row>
                </div>
                <Row style={{ marginTop: '20px' }}>
                    <Col>
                        <Button type="default" disabled>
                            {t('buy')}
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }
}
